import { useTranslation } from 'react-i18next'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import { Col, Tooltip } from 'antd'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

import { useFilters, useGeneral, useUser } from '@contexts'
import { Filters } from '@types'

dayjs.extend(isoWeek)

const RangeTimeSwitcher = () => {
  const { t } = useTranslation()
  const { filters, setFilters } = useFilters()
  const { state } = useUser()
  const isSupplier = state?.roles.some(rol => rol.name === 'SUPPLIER')
  const today = dayjs().format('MMDDYY')
  const limit = dayjs(filters?.mondayOfWeek).format('MMDDYY')
  const { setTicketToSearch, ticketToSearch } = useGeneral()

  const handlePreviewsWeek = () => {
    if (ticketToSearch) setTicketToSearch(undefined)
    setFilters((prevState: Filters) => ({
      ...prevState,
      mondayOfWeek: dayjs(filters?.mondayOfWeek)
        .day(1 - 7)
        .toDate(),
    }))
  }
  const handleNextWeek = () => {
    if (ticketToSearch) setTicketToSearch(undefined)
    setFilters((prevState: Filters) => ({
      ...prevState,
      mondayOfWeek: dayjs(filters?.mondayOfWeek)
        .day(1 + 7)
        .toDate(),
    }))
  }

  return (
    <Col className="week-handler-container">
      {isSupplier && today >= limit && !!(!filters?.evouchers && !filters?.previous) ? (
        <ArrowLeftOutlined className="arrow-disabled" />
      ) : (
        <>
          <Tooltip title={t('range_time_switcher.last_week')}>
            <ArrowLeftOutlined onClick={handlePreviewsWeek} />
          </Tooltip>
        </>
      )}
      <div>{`${dayjs(filters?.mondayOfWeek).isoWeekday(1).format('dd DD-MM-YY')} / ${dayjs(
        filters?.mondayOfWeek,
      )
        .isoWeekday(7)
        .format('dd DD-MM-YY')}`}</div>
      <Tooltip title={t('range_time_switcher.next_week')}>
        <ArrowRightOutlined onClick={handleNextWeek} disabled />
      </Tooltip>
    </Col>
  )
}

export default RangeTimeSwitcher
